import styled from 'styled-components';
import { ReactComponent as Icon } from 'Images/reveal.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 20px;
`;
Wrapper.displayName = 'Wrapper';

export const EyeIcon = styled(Icon)`
  width: 23px;
  height: 16px;

  & > path {
    fill: ${({ theme }) => theme.icons.tableHeader.color} !important;
  }
`;

EyeIcon.displayName = 'yEeIcon';
